import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

const api = async (method, path, params) => axios[method](path, params)

import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-additional-field-new-mapping-key'

const state = {
    additional_field: null,
    additional_fields: [],
    pagination: {},
    pagination_map: {},
    item: null,
    additional_fields_map: {}, // <-- NEW
}

const mutations = {
    set_additional_field(state, payload) {
        state.additional_field = payload
    },

    set_additional_fields(state, { key, fields }) {
        state.additional_fields_map = {
            ...state.additional_fields_map,
            [key]: fields,
        }
    },
    SET_PAGINATION(state, { key, pag }) {
        state.pagination_map = {
            ...state.pagination_map,
            [key]: pag,
        }
    }
}

const actions = {
    async create(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api('post', `additional-field-new-mapping`, payload)
            context.commit('set_additional_field', results.data.success.data)
            return results.data.success.data;
        } catch (err) {
            errorHandler(err)
        }
    },
    async createAdditionalFieldItem(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api(
                'post',
                `additional-field-new-mapping/create-field-item`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
            return results.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchById(context, id) {
        try {
            const results = await api('get', `additional-field-new-mapping/${id}`)
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context, { page, query }) {
        try {
            const key = `${query.modelableType}:${query.modelableId}`
    
            let results;
            if (page && page > 0) {
                page = page || 1
                results = await api('get', `additional-field-new-mapping?page=${page}&${buildQuery(query)}`)
                const {
                    data,
                    current_page: pg,
                    per_page: pageSize,
                    total,
                } = results.data.success.data
    
                const pag = { page: pg, pageSize, total }
    
                context.commit('set_additional_fields', { key, fields: data })
                context.commit('SET_PAGINATION', { key, pag })
    
            } else {
                results = await api('get', `additional-field-new-mapping?${buildQuery(query)}`)
                context.commit('set_additional_fields', {
                    key,
                    fields: results.data.success.data
                })
            }
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateAdditionalFieldItemOrder(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            await api('post', `additional-field-new-mapping/update/display/order/`, payload)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
    async update(context, payload) {
        console.log('update', payload)
        // const storageCache = new StorageCache(storageKey)
        try {
            // storageCache.reset()
            const results = await api(
                'put',
                `additional-field-new-mapping/${payload.id}`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateAdditionalFieldItem(context, payload) {
        const storageCache = new StorageCache(storageKey)
        console.log('update', payload)
        try {
            storageCache.reset()
            const results = await api(
                'put',
                `additional-field-new-mapping/update-field-item/${payload.id}`,
                payload
            )
            context.commit('set_additional_field', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            await api('delete', `additional-field-new-mapping/${id}`)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteItem(context, id) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api('delete', `additional-field-new-mapping/delete-field-item/${id}`)
            context.commit('set_additional_field', results.data.success.data)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {
    getAdditionalFields: (state) => (modelableType, modelableId) => {
        const key = `${modelableType}:${modelableId}`
        return state.additional_fields_map[key] || []
    },
    getPagination: (state) => (modelableType, modelableId) => {
        const key = `${modelableType}:${modelableId}`
        return state.pagination_map[key] || { page: 1, pageSize: 15, total: 0 }
      }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
